import { Stack, styled } from '@mui/material';

import { colors } from '../theme/theme';

export const CustomSelectWrapper = styled(Stack)(({ theme }) => ({
    '& .textFieldTitle': {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(0.5),
    },
    '& .helperTitle': {
        color: colors.bluePreset[30],
        marginTop: theme.spacing(0.5),
    },
    '& .errorTxt': {
        color: colors.errorPreset[10],
        marginTop: theme.spacing(0.5),
    },
    '& .MuiFormControl-root': {
        '& .MuiInputBase-root': {
            '& .MuiSelect-select': {
                padding: '11.5px 26px 12px 12px',
            },
            '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.primaryLight[100],
                },
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: 1,
                    borderColor: colors.primaryLight[100],
                },
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: theme.spacing(1),
                borderColor: colors.greyPreset[30],
            },
            /* Error state: red border when FormControl has error={true} (Mui-error is on InputBase) */
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.errorPreset[10],
                borderWidth: 1,
            },
            '&.MuiOutlinedInput-root': {
                ...theme.typography.body2,
                backgroundColor: colors.fullWhite,
                borderRadius: theme.spacing(1),
            },
        },
    },
}));
